// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgc_a bib_wj bib_ss bib_xl"};